import styled from 'styled-components'

export const IconTextStyle = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px 4px 0px 4px;
  font-size: x-small;
  text-align: left;
  img {
    width: 25px;
    height: 25px;
    padding-right: 0.3em;
  }
`
